import React from "react";

import { ArrowRightOutlined } from "@ant-design/icons";
import { Button } from "antd";

import { PREPAID_HOW_IT_WORKS_STEPS } from "../constants";

import { ReactComponent as PrepaidEmptyFlowerOutline } from "../../../../assets/images/subscriptions/prepaid-empty-flower-outline.svg";
import prepaidEmptyHistoryIcon from "../../../../assets/images/subscriptions/prepaid-empty-history.svg";
import prepaidEmptyRepeatIcon from "../../../../assets/images/subscriptions/prepaid-empty-repeat.svg";
import prepaidEmptyShoppingCartIcon from "../../../../assets/images/subscriptions/prepaid-empty-shopping-cart.svg";
import prepaidEmptyWalletIcon from "../../../../assets/images/subscriptions/prepaid-empty-wallet.svg";

import "./PrepaidEmptyState.css";

const STEP_ICONS = {
  "buy-before-submission": prepaidEmptyShoppingCartIcon,
  "deducted-by-category": prepaidEmptyHistoryIcon,
  "return-credits": prepaidEmptyRepeatIcon,
};

export default function UsageMetricsPrepaidEmptyState({ balance = 0, onPurchase }) {
  return (
    <section className="UsageMetricsPrepaidEmptyState">
      <div className="UsageMetricsPrepaidEmptyState__Intro">
        <span className="UsageMetricsPrepaidEmptyState__BalancePill">
          <img
            src={prepaidEmptyWalletIcon}
            alt=""
            aria-hidden
            className="UsageMetricsPrepaidEmptyState__BalanceIcon"
          />
          {`Balance: ${balance}`}
        </span>
        <h2 className="UsageMetricsPrepaidEmptyState__Heading">
          Start submitting samples with prepaid tests.
        </h2>
        <p className="UsageMetricsPrepaidEmptyState__Text">
          Buy tests in advance and use them while creating sample submissions. The user only
          pays for selected tests, and removed tests can return credits before processing.
        </p>
        {onPurchase && (
          <Button
            type="primary"
            onClick={onPurchase}
          >
            Purchase Tests
            <ArrowRightOutlined />
          </Button>
        )}
      </div>

      <aside className="UsageMetricsPrepaidEmptyState__Info">
        <PrepaidEmptyFlowerOutline
          className="UsageMetricsPrepaidEmptyState__InfoFlower UsageMetricsPrepaidEmptyState__InfoFlower--topLeft"
          aria-hidden
        />
        <PrepaidEmptyFlowerOutline
          className="UsageMetricsPrepaidEmptyState__InfoFlower UsageMetricsPrepaidEmptyState__InfoFlower--topRight"
          aria-hidden
        />
        <PrepaidEmptyFlowerOutline
          className="UsageMetricsPrepaidEmptyState__InfoFlower UsageMetricsPrepaidEmptyState__InfoFlower--bottomLeft"
          aria-hidden
        />
        <h3 className="UsageMetricsPrepaidEmptyState__InfoHeading">How Prepaid testing works ?</h3>
        <ul className="UsageMetricsPrepaidEmptyState__StepList">
          {PREPAID_HOW_IT_WORKS_STEPS.map((step) => (
            <li className="UsageMetricsPrepaidEmptyState__Step" key={step.key}>
              <span className="UsageMetricsPrepaidEmptyState__StepIcon">
                <img src={STEP_ICONS[step.key]} alt="" aria-hidden />
              </span>
              <div>
                <p className="UsageMetricsPrepaidEmptyState__StepTitle">{step.title}</p>
                <p className="UsageMetricsPrepaidEmptyState__StepDescription">{step.description}</p>
              </div>
            </li>
          ))}
        </ul>
      </aside>
    </section>
  );
}
